module.exports = __webpack_public_path__ + "static/grip-1227d632eae1d3831473820415464c7c.png";